import './index.scss';

window.addEventListener('load', function(){
  
  const numberGridSections = document.querySelectorAll('.pd-block-number-grid')

  const init = (section) => {

    gsap.from(section.querySelectorAll('.pd_number-grid li '), {
      scrollTrigger: {
        trigger: section,
        pin: false,   // pin the trigger element while active
        start: "top 80%", // when the top of the trigger hits the top of the viewport
      },
      opacity: 0,
      y: 20,
      stagger: {
        each: 0.25,
        ease: "linear"
      }
    });
  }

  numberGridSections.forEach(section => { 
    init(section)
  })

})